import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b82d8dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowMoreButton',
  props: {
  show: Boolean,
},
  emits: ['click'],
  setup(__props, { emit }) {





function onClick() {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    "enter-active-class": "animated fadeIn",
    "leave-active-class": "animated fadeOut"
  }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_btn, {
              class: "more-button absolute-bottom-right z-index-1 q-mr-sm q-mb-sm",
              color: "accent",
              fab: "",
              icon: "arrow_downward",
              padding: "xs",
              onClick: onClick
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})